import React from "react";
import { Link } from "react-router-dom";

const FooterLinks = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
      <div className="space-y-4">
        {/* <Link to="/" className="flex items-center">
          <span className="text-xl font-bold bg-gradient-to-r from-violet-600 to-indigo-600 bg-clip-text text-transparent">
            MindPulse<span className="font-normal">Therapy</span>
          </span>
        </Link> */}
        <p className="text-sm text-gray-600">
          Connecting diverse communities with culturally competent therapists.
        </p>
      </div>
      <div>
        <h3 className="font-semibold text-sm uppercase tracking-wider mb-4">For Patients</h3>
        <ul className="space-y-2">
          <li>
            <Link to="/how-it-works" className="text-sm text-gray-600 hover:text-violet-600">
              How It Works
            </Link>
          </li>
          <li>
            <Link to="/assessment" className="text-sm text-gray-600 hover:text-violet-600">
              Take Assessment
            </Link>
          </li>
          <li>
            <Link to="/browse-therapists" className="text-sm text-gray-600 hover:text-violet-600">
              Browse Therapists
            </Link>
          </li>
        </ul>
      </div>
      <div>
        <h3 className="font-semibold text-sm uppercase tracking-wider mb-4">For Therapists</h3>
        <ul className="space-y-2">
          <li>
            <Link to="/therapist-features" className="text-sm text-gray-600 hover:text-violet-600">
              Features
            </Link>
          </li>
          <li>
            <Link to="/join-as-therapist" className="text-sm text-gray-600 hover:text-violet-600">
              Join Our Network
            </Link>
          </li>
          <li>
            <Link to="/therapist-resources" className="text-sm text-gray-600 hover:text-violet-600">
              Resources
            </Link>
          </li>
        </ul>
      </div>
      <div>
        <h3 className="font-semibold text-sm uppercase tracking-wider mb-4">Company</h3>
        <ul className="space-y-2">
          <li>
            <Link to="/about" className="text-sm text-gray-600 hover:text-violet-600">
              About Us
            </Link>
          </li>
          <li>
            <Link to="/faq" className="text-sm text-gray-600 hover:text-violet-600">
              FAQs
            </Link>
          </li>
          <li>
            <Link to="/contact" className="text-sm text-gray-600 hover:text-violet-600">
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </div>
  )
}

const FooterBase = () => {
  return(
    <div className="border-t border-gray-200 mt-8 pt-8">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="flex space-x-6 mb-4 md:mb-0">
          <Link to="/" className="text-xs text-gray-600 hover:text-violet-600">
            Privacy Policy
          </Link>
          <Link to="/" className="text-xs text-gray-600 hover:text-violet-600">
            Terms of Service
          </Link>
        </div>
        <div className="text-xs text-gray-500">
          © {new Date().getFullYear()} MindPulse Therapy. All rights reserved.
        </div>
      </div>
      
      <div className="mt-6 p-4 bg-gray-100 rounded-lg">
        <h3 className="font-medium text-sm mb-2">🔐 Trust & Compliance</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex items-center space-x-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-500">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
            <span className="text-xs">HIPAA-compliant platform</span>
          </div>
          <div className="flex items-center space-x-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-500">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            <span className="text-xs">Verified therapists</span>
          </div>
          <div className="flex items-center space-x-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-500">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
            <span className="text-xs">Secure data encryption</span>
          </div>
        </div>
      </div>
    </div>
  )
}

const Footer = () => {
  return (
    <footer className="bg-background/30 py-12 mt-16">
      <div className="container px-4 md:px-6">
        <FooterBase />
      </div>
    </footer>
  );
};

export default Footer;
